import React from "react";

/* Mapped colours per upsell target product */
export const UPSELL_TARGETS = {
  receivables:    { label: "Receivables",            color: "#3b82f6", bg: "rgba(59, 130, 246, 0.08)", border: "rgba(59, 130, 246, 0.25)", path: '/receivables/customers' },
  cashflow:       { label: "Cash Flow Intelligence", color: "#14b8a6", bg: "rgba(20, 184, 166, 0.08)", border: "rgba(20, 184, 166, 0.25)", path: '/cashflow/forecast/table' },
  creditcheck:    { label: "Credit Check",           color: "#8b5cf6", bg: "rgba(139, 92, 246, 0.08)", border: "rgba(139, 92, 246, 0.25)", path: '/receivables/credit-check' },
  collections:    { label: "Collections",            color: "#ef4444", bg: "rgba(239, 68, 68, 0.08)", border: "rgba(239, 68, 68, 0.25)", path: '/receivables/collections' },
};

/* ── LockedSection — frosted overlay + CTA, used inside module bodies ── */
export function LockedSection({ target = "receivables", ctaText, isFree = false, children }) {
  const t = UPSELL_TARGETS[target] || UPSELL_TARGETS.receivables;
  return (
    <div className="drm-locked">
      <div className="drm-locked--blur">{children}</div>
      <div className="drm-locked--overlay" style={{ background: `linear-gradient(180deg, transparent, ${t.bg} 50%)` }}>
        <div className="drm-locked--cta" style={{ color: t.color, borderColor: t.border, background: "#fff" }}>
          {isFree ? (
            <span className="drm-locked--badge drm-locked--badge--free">FREE</span>
          ) : (
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
            </svg>
          )}
          <span>{ctaText || `Unlock with ${t.label}`}</span>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
          </svg>
        </div>
      </div>
    </div>
  );
}

export function UpsellFooter({ target, text, isFree = false, label, path, onLinkClick }) {
  const t = UPSELL_TARGETS[target] || UPSELL_TARGETS.receivables;
  return (
    <div className="drm-upsell-footer" style={{ borderColor: t.border, background: t.bg }}>
      <span className="drm-upsell-footer--text">{text}</span>
      <a className="drm-upsell-footer--cta" style={{ color: t.color }} href={path || t.path} onClick={onLinkClick}>
        {isFree && <span className="drm-upsell-footer--free">FREE</span>}
        <span className="drm-upsell-footer--label">{label || t.label}</span>
        <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
        </svg>
      </a>
    </div>
  );
}
